import type { CSSProperties, ReactNode } from 'react';
import React from 'react';
import ReactModal from 'react-modal';

import type { SafariCompatModalProps as ModalProps } from '../../../styles/SafariCompatModal';
import { SafariCompatModal as Modal } from '../../../styles/SafariCompatModal';
import * as styles from '../styles/SimpleModal.styles';

const CLOSE_TIMEOUT_MS = 250;

export interface SimpleModalProps extends ModalProps {
  children: ReactNode | undefined;
  contentLabel: string;
  contentStyles?: CSSProperties;
  isOpen: boolean;
  onAfterClose?: () => void;
  onRequestClose: () => void;
}

const SIMPLE_MODAL_CONTENT_CLASS_NAMES: styles.SimpleModalGlobalStylesProps['contentClassNames'] = {
  base: 'simple-modal-content',
  afterOpen: 'simple-modal-content--afterOpen',
  beforeClose: 'simple-modal-content--beforeClose',
};

const SIMPLE_MODAL_OVERLAY_CLASS_NAMES: styles.SimpleModalGlobalStylesProps['overlayClassNames'] = {
  base: 'simple-modal-overlay',
  afterOpen: 'simple-modal-overlay--afterOpen',
  beforeClose: 'simple-modal-overlay--beforeClose',
};

const SimpleModalGlobalStyles = styles.SimpleModalGlobalStyles({
  contentClassNames: SIMPLE_MODAL_CONTENT_CLASS_NAMES,
  overlayClassNames: SIMPLE_MODAL_OVERLAY_CLASS_NAMES,
  closeTimeoutMS: CLOSE_TIMEOUT_MS,
});

export const SimpleModal = ({
  children,
  contentLabel,
  contentStyles,
  isOpen,
  onAfterClose,
  onRequestClose,
}: SimpleModalProps) => (
  <>
    <SimpleModalGlobalStyles />
    <Modal
      ariaHideApp={false}
      className={SIMPLE_MODAL_CONTENT_CLASS_NAMES}
      closeTimeoutMS={CLOSE_TIMEOUT_MS}
      contentLabel={contentLabel}
      isOpen={isOpen}
      onAfterClose={onAfterClose}
      onRequestClose={onRequestClose}
      overlayClassName={SIMPLE_MODAL_OVERLAY_CLASS_NAMES}
      style={{
        // @ts-ignore
        content: contentStyles,
      }}
    >
      {children}
    </Modal>
  </>
);

export const setSimpleModalAppElement = ReactModal.setAppElement;
